import { useState, useEffect } from 'react';

const NAV_ITEMS = [
  { href: '#hero', label: '首页' },
  { href: '#index', label: '专题合集' },
  { href: '#updates', label: '更新快讯' },
  { href: '#features', label: '平台优势' },
  { href: '#ranking', label: '人气榜单' },
  { href: '#app', label: 'APP体验' },
  { href: '#contact', label: '投稿咨询' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-[72px]">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 cursor-pointer"
          >
            <span className="text-2xl font-heading text-primary-500 tracking-wide">99漫画</span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-3 py-2 text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer rounded-md hover:bg-primary-50/70"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>

        {mobileOpen && (
          <nav className="md:hidden pb-4 border-t border-background-200/50 pt-3 animate-fade-in-down">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="block px-4 py-3 text-sm text-foreground-700 hover:text-primary-500 hover:bg-primary-50/50 transition-colors rounded-md cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
}